import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface NewProjectDialogCtx {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const Ctx = createContext<NewProjectDialogCtx | null>(null);

export function NewProjectDialogProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return <Ctx.Provider value={{ isOpen, open, close }}>{children}</Ctx.Provider>;
}

export function useNewProjectDialog(): NewProjectDialogCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useNewProjectDialog must be used within NewProjectDialogProvider");
  return ctx;
}
